import $ from 'jquery';
import whatInput from 'what-input';


window.$ = $;

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();

$(document).ready(function(){
	$('#nav-icon').click(function(){
		$('#nav-icon').toggleClass('open');
		revealOverlay();
	});
});

//////////////////////////////
// Reveal menu with revealOverlay()
//////////////////////////////

function revealOverlay() {
  document.getElementById("overlayMenu").classList.toggle("overlay-reveal");
  document.body.classList.toggle('noscroll');
}

// Rename drilldown back

$('.new-back').each(function(){
  var backTxt = $(this).parent().closest('.is-drilldown-submenu-parent').find('> a').text();
  $(this).text(backTxt);
});

if (jQuery('.js-drilldown-back').length) {
    jQuery('.js-drilldown-back').each(function () {
        jQuery('.js-drilldown-back').find('a').text('Tilbake');
    });
}



  // ScrollReveal //
  ScrollReveal().reveal('.fade-scale-in', {
    duration: 1000,
    scale: 0.85    
}); 
ScrollReveal().reveal('.fade-in', {
    duration: 2000
}); 
ScrollReveal().reveal('.delay-250', {
    delay: 250
});
ScrollReveal().reveal('.delay-500', {
    delay: 500
});
ScrollReveal().reveal('.delay-600', {
    delay: 600
});



document.getElementById("currentYear").innerHTML = new Date().getFullYear();